import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Tab.css';

class Tab extends Component {

  handleClick = () => {
    const { tabKey, activeTab } = this.props;
    this.props.handleClick(tabKey);
    this.props.onClickHandler();
  }

  render() {
    const {
      handleClick,
      props: {
        activeTab,
        label,
        tabKey
      },
    } = this;

    let className = 'tab-list-item';

    if (activeTab === tabKey) {
      className += ' tab-list-active';
    }

    return (
      <li 
        onClick={handleClick} 
        className={className}
      >
        {label}
      </li>
    );
  }
}

Tab.propTypes = {
  activeTab: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Tab;


// WEBPACK FOOTER //
// ./src/components/UI/Tab/Tab.js